<template lang="html">
    <div class="item" :class="{ active: active }">
        <div @click.prevent="makeActive" v-on-clickaway="cancel" data-cy="makeActive">
            <span class="handle">
                <img src="@/assets/arrows-up-down-dark-green.svg" />
            </span>

            <input
                :disabled="inputDisabled < 1"
                class="club"
                @focus="focusClub"
                autocomplete="nope"
                @input="saveValue"
                data-cy="club"
                ref="club"
                type="text"
                maxlength="255"
                v-model="form.club"
            />
            <i
                ><input
                    :disabled="inputDisabled < 1"
                    @focus="focusModel"
                    autocomplete="nope"
                    @input="saveValue"
                    data-cy="yd"
                    class="yd"
                    type="number"
                    maxlength="11"
                    v-model="form.yd"
                />
                yds</i
            >
            <span class="clear"></span>
        </div>
        <img @click.prevent="openDelete" data-cy="bin" class="bin" src="~@/assets/icons/bin.svg" />

        <div class="error" data-cy="error" v-if="form.errors.any()">
            Please ensure you have added the details in full
        </div>

        <!--<form class="saveYardage" v-if="open">
          <button :disabled="form.busy" data-cy="update yardage" @click.prevent="updateYardage" class="button half" type="button" name="button">Update club</button>
          <button @click.prevent="cancel" class="button half cancel" type="button" name="button">Cancel</button>
      </form>-->

        <form class="deleteYardage" v-if="deleteOpen">
            <p>Are you sure you want to delete this yardage?</p>
            <button
                data-cy="deleteYard"
                :disabled="form.busy"
                @click.prevent="deleteYardage"
                class="button half"
                type="button"
                name="button"
            >
                Yes, delete
            </button>
            <button
                @click.prevent="deleteOpen = false"
                class="button half cancel"
                type="button"
                name="button"
            >
                No, cancel
            </button>
        </form>
    </div>
</template>

<script>
import { debounce } from "debounce";
import { mixin as clickaway } from "vue-clickaway";
import { Form } from "vform";
export default {
    name: "yardage-item",
    mixins: [clickaway],
    props: {
        yardage: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    created() {
        this.form.fill(this.yardage);
    },
    data() {
        return {
            inputDisabled: 0,
            active: false,
            open: false,
            deleteOpen: false,
            form: new Form({
                id: "",
                user_id: "",
                club: "",
                yd: "",
                order: "",
            }),
        };
    },
    methods: {
        makeActive() {
            this.active = true;
            //this.open = true;
            this.inputDisabled++;
        },
        focusClub() {
            if (this.form.club == "Club...") {
                this.form.club = "";
            }
        },
        focusModel() {
            if (this.form.yd == "0") {
                this.form.yd = "";
            }
        },
        openDelete() {
            this.deleteOpen = true;
        },
        saveValue: debounce(function () {
            this.updateYardage();
        }, 500),
        updateYardage() {
            this.form.put("/yardage/" + this.yardage.id).then((response) => {
                this.$store.state.user.yardages = response.data;
            });
        },
        deleteYardage() {
            this.form.delete("/yardage/" + this.yardage.id).then(() => {
                this.$notify({
                    duration: 1000,
                    text: "Yardage deleted",
                });
            });

            this.$store.dispatch("deleteYardageItem", this.yardage);
        },
        cancel() {
            //this.$store.state.mobNavFix = false;
            this.open = false;
            this.active = false;
            this.inputDisabled = 0;
        },
    },
};
</script>

<style lang="scss" scoped>
.saveYardage,
.deleteYardage {
    background: white;
    padding: 25px;
    position: fixed;
    bottom: 0px;
    width: 100%;
    left: 0px;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    box-shadow: 0px -20px 10px rgba(0, 0, 0, 0.1);
    z-index: 3;
    p {
        margin-bottom: 20px;
        text-align: center;
        color: $green_0;
    }
}
.deleteYardage {
    z-index: 4;
}
.clear {
    display: block;
    clear: both;
}
</style>
